import { render, staticRenderFns } from "./Sucursal.vue?vue&type=template&id=1fa649ee&scoped=true"
import script from "./Sucursal.vue?vue&type=script&lang=js"
export * from "./Sucursal.vue?vue&type=script&lang=js"
import style0 from "./Sucursal.vue?vue&type=style&index=0&id=1fa649ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa649ee",
  null
  
)

export default component.exports